import { render, staticRenderFns } from "./AgeRequirementSyncRadio.vue?vue&type=template&id=3dedb880&"
import script from "./AgeRequirementSyncRadio.vue?vue&type=script&lang=js&"
export * from "./AgeRequirementSyncRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports